<template>
  <section class="section-login-body">
    <div class="row">
      <div class="login">
        <div class="login__form">
          <form
            class="form"
            @submit.prevent="login"
          >
            <div class="u-margin-bottom-medium">
              <h2 class="heading-secondary">
                Signup
              </h2>
            </div>

            <div class="form__group">
              <input
                id="email"
                v-model="email"
                type="text"
                class="form__input form__input__login"
                placeholder="Email Address"
                required
                autocomplete="off"
              >
              <label
                for="email"
                class="form__label"
              >Email</label>
            </div>

            <div class="form__group u-margin-bottom-small">
              <input
                id="Password"
                v-model="passwprd"
                type="password"
                class="form__input form__input__login"
                placeholder="Password"
                required
                autocomplete="off"
              >
              <label
                for="password"
                class="form__label"
              >Password</label>
            </div>

            <div
              v-if="feedback"
              class="form__group"
            >
              <label
                for="email"
                class="form__label"
              >{{ feedback }}</label>
            </div>

            <div
              class="form__group"
              style="margin-bottom: 4rem;"
            >
              <a
                href="#"
                class="btn-text"
                style="float:left;"
                @click.prevent="lostPassword()"
              >Privacy Policy &rarr;</a>
              <button
                class="btn btn--primary"
                style="float:right;"
                @click.prevent="signup"
              >
                Signup
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {

  name: 'SignUp',
  data () {
    return {
      email: null,
      password: null,
      feedback: null
    }
  },
  methods: {
    signup () {
      if (this.email && this.password) {
        firebase.auth().createUserWithEmailAndPassword(this.email, this.password)
          .then(cred => {
            if (cred.additionalUserInfo.isNewUser === true) {
              // verify the new user by email
              const user = firebase.auth().currentUser
              user.sendEmailVerification()
                .then(() =>
                // Push to a temp holding page if not verified
                  this.$router.push({ name: 'UserNotVerified' }))
            } else {
              this.$router.push({ name: 'Home' })
            }
          })
          .catch(err => {
            console.log(err)
            this.feedback = err.message
          })
      } else {
        this.feedback = 'You must enter all fields'
      }
    }
  }
}
</script>
